import {
  FETCH_PENDING_CONTENTS_REQUEST,
  FETCH_PENDING_CONTENTS_SUCCESS,
  FETCH_PENDING_CONTENTS_FAILURE,
  APPROVE_CONTENT_REQUEST,
  APPROVE_CONTENT_SUCCESS,
  APPROVE_CONTENT_FAILURE,
  REJECT_CONTENT_REQUEST,
  REJECT_CONTENT_SUCCESS,
  REJECT_CONTENT_FAILURE,
  SET_CONTENT_APPROVAL_FILTERS,
  CLEAR_CONTENT_APPROVAL_ERROR,
  RESET_CONTENT_APPROVAL_STATE
} from './_actionTypes';

const initialState = {
  pendingContents: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 20
  },
  filters: {
    courseId: null,
    page: 1,
    limit: 20
  },
  loading: false,
  actionLoading: {},
  error: null,
  success: null
};

const contentApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PENDING_CONTENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_PENDING_CONTENTS_SUCCESS:
      console.log('Reducer received payload:', action.payload);
      return {
        ...state,
        loading: false,
        pendingContents: Array.isArray(action.payload.data) 
          ? action.payload.data 
          : [],
        pagination: action.payload.pagination || {
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
          itemsPerPage: 20
        },
        error: null
      };

    case FETCH_PENDING_CONTENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case APPROVE_CONTENT_REQUEST:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: true
        },
        error: null
      };

    case APPROVE_CONTENT_SUCCESS:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: false
        },
        pendingContents: state.pendingContents.filter(
          content => content.id !== action.payload
        ),
        success: 'Content approved successfully',
        error: null
      };

    case APPROVE_CONTENT_FAILURE:
      return {
        ...state,
        actionLoading: {},
        error: action.payload
      };

    case REJECT_CONTENT_REQUEST:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload.contentId]: true
        },
        error: null
      };

    case REJECT_CONTENT_SUCCESS:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: false
        },
        pendingContents: state.pendingContents.filter(
          content => content.id !== action.payload
        ),
        success: 'Content rejected successfully',
        error: null
      };

    case REJECT_CONTENT_FAILURE:
      return {
        ...state,
        actionLoading: {},
        error: action.payload
      };

    case SET_CONTENT_APPROVAL_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      };

    case CLEAR_CONTENT_APPROVAL_ERROR:
      return {
        ...state,
        error: null,
        success: null
      };

    case RESET_CONTENT_APPROVAL_STATE:
      return initialState;

    default:
      return state;
  }
};

export default contentApprovalReducer;